import React from 'react';
import '../styles/QuestionGameSummary.css';
import { renderItemOrText } from '@utils/renderUtils.jsx';
import ItemIcon from '@components/ItemIcon.jsx';
import { UseQuestionGameSummaryController } from '../controllers/useQuestionGameSummaryController.jsx';

export default function QuestionGameSummary({ scoreboard, questions, handleLeaveLobby, handleReturnToLobby }) {
    const {
        expandedPerPlayer,
        getRankedPlayers,
        getMedalClass,
        toggleQuestion,
        renderQuestion
    } = UseQuestionGameSummaryController(questions);

    const rankedScoreboard = getRankedPlayers(scoreboard);

    return (
        <>
            <div className="game-summary-title">
                <h1><i className="fas fa-trophy"></i> Spiel beendet!</h1>
            </div>
            <div className="game-summary-wrapper">
                <div className="summary-grid">
                    {rankedScoreboard.map(player => (
                        <div key={player.persistentId} className={`summary-card ${getMedalClass(player.rank)}`}>
                            <div className="summary-header">
                                <div className="summary-name">
                                    <i className="fas fa-user"></i> {player.name}
                                </div>
                                <div className="summary-score">
                                    <i className="fas fa-star"></i> {player.score} Punkte
                                </div>
                            </div>

                            <div className="answers-container expanded">
                                {player.answers.map((ans, index) => {
                                    if (ans == null) return null;
                                    return (
                                    <div
                                        key={index}
                                        className="summary-answer-item"
                                        onClick={() => toggleQuestion(player.persistentId, index)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="answer-header">
                                            <div className={`question-teaser ${expandedPerPlayer[player.persistentId]?.[index] ? 'expanded' : ''}`}>
                                                <i className="fas fa-question-circle"></i>{' '}
                                                {renderQuestion(index, ItemIcon, renderItemOrText)}
                                            </div>
                                            {ans.didNotAnswer ? (
                                                <i className="fas fa-clock" style={{ color: 'orange' }}></i>
                                            ) : ans.selected === ans.correct ? (
                                                <i className="fas fa-check" style={{ color: 'lightgreen' }}></i>
                                            ) : (
                                                <i className="fas fa-times" style={{ color: 'salmon' }}></i>
                                            )}
                                        </div>

                                        {expandedPerPlayer[player.persistentId]?.[index] && (
                                            <div className="answer-content">
                                                <p><strong>Geantwortet:</strong>{' '}
                                                    {ans.selected
                                                        ? ans.selected
                                                            .split(/\s*\+\s*/).map(part => part.trim())
                                                            .map((part, idx) => renderItemOrText(part, 20, idx))
                                                        : 'Keine Antwort'}
                                                </p>
                                                {ans.selected !== ans.correct && !ans.didNotAnswer && (
                                                    <p className="correct-answer">
                                                        <strong>Richtige Antwort:</strong> {ans.correct}
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="summary-actions">
                    <button className="button button-primary" onClick={handleReturnToLobby}>
                        <i className="fas fa-users"></i> Zurück zur Lobby
                    </button>
                    <button className="button button-primary" onClick={handleLeaveLobby}>
                        <i className="fas fa-home"></i> Zurück zur Startseite
                    </button>
                </div>
            </div>
        </>
    );
}
